<template>
    <div id="wrap">
        <div class="header" :class={on:isPlayer}>
            <div class="rectangle_logo">
                <img src="./images/图标@2x.png" alt="">
            </div>
            <div class="rectangle_text">
                <div class="text_title">听书王</div>
                <div class="text_scribe">真人播讲的有声小说</div>
            </div>
            <div class="rectangle_download" id="download"  ref="openAppBtn">
                <div class="span">下载APP</div>
            </div>
        </div>
        <div class="box">
            <div class="play_wrap">
                <div class="detail_book">
                    <div class="book_logo">
                        <div class="logo_image">
                            <img :src="bookdetails.bookpic"  alt="加载失败">
                        </div>
                        <div class="look_times">
                            <div class="playback"><img src="./images/播放次数@2x.png" alt="观看数"></div>
                            <div class="playcount"><span>{{playcount}}</span></div>
                        </div>
                    </div>
                    <div class="book_person">
                        <div class="book_name">{{bookdetails.bookname}}</div>
                        <div class="original_person">原著：{{bookdetails.bookauthor}}</div>
                        <div class="book_dub">播音：{{bookdetails.announcer}}</div>
                        <div class="book_times">
                            <div class="book_gather">
                                <div class="chapter"><img src="./images/web书籍详情-长页面@2x.png" alt="剧集数"></div>
                                <div class="booknumber"><span>{{bookdetails.booknumber}}集</span></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="player">
                <div class="player_box">
                    <div class="player_episode">
                        <div class="playerName">{{firstchaptername}}</div>
                    </div>
                    <div class="player_progress">
                        <div class="current_Time"><span ref="nowTime">00:00</span></div>
                        <!--            主进度条-->
                        <div class="progress" @click="progress($event)" ref=progress>
                            <div class="smallGrey" ref="smallGrey">

                                <div class="smallWhite" style="transform: translateX(0)" ref="smallWhite" @touchstart = "touchStart"></div>
                                <div class="smallPink" ref="smallPink"></div>
                            </div>

                        </div>
                        <div class="all_Time"><span ref="allTime">{{firstchapterduration}}</span></div>
                    </div>
                    <div class="menu">
                        <!--               音频组件-->
                        <audio id="myAudio" ref="myAudio"   preload="auto" controls="controls" v-show="false"></audio>
                        <!--                底部标签栏-->
                        <!--                按钮排-->
                        <div class="lastSong" @click="lastSong"><img src="./images/上一集@2x.png" alt="加载失败"></div>
                        <div class="menu_btn"  @click="playAll" >
                            <div class="menu_btn_start" :class="{on:isStart}"><img src="./images/播放@2x.png" alt="加载失败"></div>
                            <div class="menu_btn_timg" :class="{on:isTimg}"><img src="./images/加载@2x.png" alt="加载失败"></div>
                            <div class="menu_btn_pause" :class="{on:isPause}"><img src="./images/暂停@2x.png" alt="加载失败"></div>
                        </div>
                        <div class="nextSong" @click="lastSong"><img src="./images/下一集@2x.png" alt="加载失败"></div>
                    </div>
                </div>
            </div>
            <div class="play_catail"  ref="playCatail">
                <div class="detail_all">
                    <div class="book_content">
                        <div class="content_title">内容简介</div>
                        <div class="content_introduce"> {{bookdetails.profile}}</div>
                    </div>
                    <div class="guess_title"><span>热门有声小说</span></div>
                    <ul class="guess_list">
                        <li class="guess_items" v-for="(item,index) in items"  :key="index" @click="getIndex(index)"  >
                            <div class="book_logo">
                                <img :src='item.bookpic' ref="logo"  alt="123" >
                            </div>
                            <div class="book_title">
                                <span>{{item.bookname}}</span>
                            </div>
                        </li>
                    </ul>
                </div>

            </div>
            <div class="detail_play" id="download" :class={on:isPlayer}>
                <div class="detail_box">
                    <div class="play_span">下载APP，免费畅听</div>
                </div>
            </div>
            <div class="curtain" :class="{on:!curtain}" @touchmove.prevent>
                <div class="promptBox"  >
                    <div class="promptFork" :class="{on:!curtain}" @click="curtain=true">
                        <img src="./images/关闭@2x.png" alt="">
                    </div>
                    <div class="curtain_download">下载听书王APP</div>
                    <div class="unchain">全站热门小说免费听哦～</div>
                    <div class="curtainBtn" id="dowmload"><span>立即下载</span></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import axios from 'axios';
    // import $ from 'jquery'
    // const script = document.createElement('script')
    // script.src = 'https://s4.cnzz.com/z_stat.php?id=1278736774&web_id=1278736774'
    // script.language = 'JavaScript'
    // document.body.appendChild(script)
    export default {
        name: "Catail",
        data(){
            return{
                bookid:0,
                isPlayer:false,
                curtain:true,
                isStart:true,
                isTimg:false,
                isPause:false,
                startpos:0,
                endpos:20,
                lists:{},
                bookdetails: {},
                id: 0,
                bookname: "",
                bookpic: "",
                bookauthor: "",
                announcer: "",
                playcount: "",
                booknumber: "",
                allTime:0,
                timer:null,
                isAppear:true,
                touchStartX: 0,
                item:'',
                items:{},
                touchEndX:0,
                isCollection:false,
                isShow:true,
                chaptername:'',
                chapterid:0,
                firstchaptername:'',
                firstchapterduration:'',
                firstchaptermp3path:'',
                loginWay:false,
                scale:0,
                duration:0,
                brands : {
                    "IPHONE": "IPHONE|IPAD|IPOD|IOS",
                    "OPPO": "OPPO",
                    "VIVO": "VIVO",
                    "HONOR": "HONOR",
                    "HUAWEI": "HUAWEI",
                    "XIAOMI": "XIAOMI|REDMI",
                    "360": "1801-A01|1707-A01|1509-A00",
                    "SAMSUNG": "SAMSUNG"
                },
                hasOwnProp:'',
                userAgent:'',
                os:'',
                brand:'',
            }
        },
        methods:{
            windowScroll () {
                // 滚动条距离页面顶部的距离
                // 以下写法原生兼容
                let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
                // console.log(scrollTop)
                if (scrollTop < 100){
                    this.isPlayer = false;
                }else if (scrollTop > 100){
                    this.isPlayer = true;
                }
            },
            //开始播放和暂停
            playAll(){
                if (this.$refs.myAudio.paused) {
                    this.start()
                } else {
                    this.stop();
                }
            },
            start(){
                clearInterval(this.timer);
                this.isStart = false;
                this.isTimg = true;
                this.isPause = false;
                this.$refs.myAudio.play();
                this.timer = setInterval( ()=> {
                    this.move();
                },1000);
            },
            stop(){
                this.isStart = true;
                this.isTimg = false;
                this.isPause = false;
                this.$refs.myAudio.pause();
                clearInterval(this.timer)
            },
            //进度条
            move() {
                this.isTimg = false;
                this.isStart = false;
                this.isPause = true;
                this.scale = this.$refs.myAudio.currentTime/this.$refs.myAudio.duration
                this.$refs.smallWhite.style.transform = 'translateX('+this.scale*(this.$refs.smallGrey.offsetWidth-this.$refs.smallWhite.offsetWidth)+'px)'
                this.$refs.smallPink.style.width =  this.scale*(this.$refs.smallGrey.offsetWidth-this.$refs.smallWhite.offsetWidth)+'px';
                //更新当前时间
                this.$refs.nowTime.innerHTML = this.changeTime(this.$refs.myAudio.currentTime) ;
                if(this.$refs.myAudio.currentTime === this.$refs.myAudio.duration){
                    this.stop();
                    this.curtain = false;
                }
            },
            //时间转换格式
            changeTime(time){
                time = parseInt(time);
                this.top_msg = time;
                let m=this.toZero(Math.floor(time%3600/60));
                let s=this.toZero(Math.floor(time%60));
                return m+":"+s;
            },
            toZero(mun){
                if(mun<10){
                    mun = "0"+mun;
                }else{
                    mun = ""+mun;
                }
                return mun;
            },

            //上一首，下一首
            lastSong(){
                // this.isPause = false;
                this.stop();
                this.curtain = false;
            },
            //点击进度条
            progress(event){
                clearInterval(this.timer);
                let x = event.clientX - this.$refs.progress.getBoundingClientRect().left -10 ;
                // console.log(event.clientX);
                // console.log(this.$refs.progress.getBoundingClientRect().left );


                this.$refs.smallWhite.style.transform = 'translateX('+x+'px)'
                this.$refs.smallPink.style.width =  x+'px';



                // this.$refs.smallPink.style.width = this.$refs.smallWhite.style.left = x + 'px';
                //视频进度 = 当前时间/总时间 = 小粉宽（小白left）/(小灰宽-小白宽)
                this.$refs.myAudio.currentTime = this.$refs.myAudio.duration*x/(this.$refs.smallGrey.offsetWidth-this.$refs.smallWhite.offsetWidth);
                //更新当前时间
                this.$refs.nowTime.innerHTML = this.changeTime(this.$refs.myAudio.currentTime);
                this.timer = setInterval( ()=> {
                    this.move();
                },1000);
            },
            //拖拽
            touchStart(event){
                this.whiteMove(event.changedTouches[0]);
                let smallWhite = this.$refs.smallWhite;
                smallWhite.addEventListener("touchmove", this.touchMove);
                smallWhite.addEventListener("touchEnd", this.touchEnd);
                smallWhite.addEventListener("touchStart", this.touchStart);
                this.start()
            },
            touchMove(event){
                this.whiteMove(event.changedTouches[0]);
            },
            touchEnd(event){
                let smallWhite = this.$refs.smallWhite;
                smallWhite.addEventListener("touchmove", this.touchMove);
                smallWhite.addEventListener("touchEnd", this.touchEnd);
                smallWhite.addEventListener("touchStart", this.touchStart);
                this.whiteMove(event.changedTouches[0]);
            },
            //拖动进度条
             whiteMove(event) {
                 event.cancelBubble=true;
                 let scale = event.clientX - this.$refs.progress.getBoundingClientRect().left - 10;
                 console.log(scale)
                 if (scale < 0){
                     scale = 0;
                 }else if(scale > this.$refs.myAudio.duration){
                     scale = this.$refs.myAudio.duration - 1;
                 }
                 this.$refs.smallWhite.style.transform = 'translateX('+scale+'px)'
                 this.$refs.smallPink.style.width =  scale +'px';
                 // this.$refs.smallPink.style.width = this.$refs.smallWhite.style.left = scale + 'px';
                 //视频进度 = 当前时间/总时间 = 小粉宽（小白left）/(小灰宽-小白宽)
                 this.$refs.myAudio.currentTime = this.$refs.myAudio.duration*scale/(this.$refs.smallGrey.offsetWidth-this.$refs.smallWhite.offsetWidth);
                 //更新当前时间
                 this.$refs.nowTime.innerHTML = this.changeTime(this.$refs.myAudio.currentTime);
                 this.start();
             },
            //路由传参
            fetchCaseInfo(){
                this.bookid = this.$route.params.bookid;
                console.log(this.bookid)
                this.$router.push({ name: 'catail', params: { bookid: this.bookid }});
                axios.post('http://47.93.18.240/bookdetails.php', {  "username":13888888888,
                    "bookid":this.bookid   })
                    .then(resp => {
                        this.bookdetails = resp.data.data.bookdetails;
                        this.items = resp.data.data.recommend.recommend_array;
                    }).catch(err => {
                    console.log('请求失败：'+err.status+','+err.statusText);
                });
            },
            //猜你喜欢
            getIndex(index){
                // window.addEventListener('scroll', this.windowScroll);
                this.stop();
                this.scale = 0;
                this.$refs.myAudio.currentTime = 0;
                this.$refs.smallPink.style.width = this.$refs.smallWhite.style.left = this.scale*(this.$refs.smallGrey.offsetWidth-this.$refs.smallWhite.offsetWidth)+'px';
                this.$refs.nowTime.innerHTML = this.changeTime(this.$refs.myAudio.currentTime);
                let bookid = this.items[index].bookid;
                this.$router.push({ name: 'catail', params: { bookid: bookid }});
                axios.post('http://47.93.18.240/bookdetailstoh5.php', {"username":"13888888888","bookid":bookid})
                    .then(resp => {
                        this.bookdetails = resp.data.data.bookdetails;
                        this.items = resp.data.data.recommend.recommend_array;
                        this.firstchaptername = this.bookdetails.firstchaptername;
                        this.$refs.myAudio.src = this.bookdetails.firstchaptermp3path;
                        this.firstchapterduration = this.bookdetails.firstchapterduration;
                        let playcount = this.bookdetails.playcount;
                        if (playcount.length < 5){
                            this.playcount = playcount;
                            // console.log(this.playcount)
                            return this.playcount;
                        }else {
                            let decimal = playcount.substring(playcount.length - 4, playcount.length - 4);
                            // let playcount1 = playcount.toNumber
                            this.playcount = parseFloat(parseInt(playcount / 10000) + '.' + decimal) + '万';
                            // console.log(this.playcount)
                            return this.playcount
                        }
                    }).catch(err => {
                    console.log('请求失败：'+err.status+','+err.statusText);
                });

            }
            // openApp(){
            //     let device_type = navigator.userAgent;//获取userAgent信息
            //     let ua_pub = window.navigator.userAgent;
            //     let u = navigator.userAgent;
            //     let isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; //android终端
            //     let ua = window.navigator.userAgent.toLowerCase();
            //     let isWeixin = ua.indexOf('micromessenger') !== -1;
            //     let href = window.location.href;
            //     console.log(this)
            //     window._czc.push(['_trackEvent', '软件', '下载','听书王','1','download'])
            //     if (isWeixin)
            //     {
            //         window.location.href = "https://a.app.qq.com/o/simple.jsp?pkgname=com.fanqie.fqtsa";
            //         return true;
            //     }
            //     else if(ua_pub.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)){
            //         return
            //         // window.location.href = 'https://itunes.apple.com/cn/app/%E8%B6%A3%E5%90%AC%E5%B0%8F%E8%AF%B4-%E6%9C%89%E5%A3%B0%E5%B0%8F%E8%AF%B4%E6%87%92%E4%BA%BA%E5%90%AC%E4%B9%A6%E7%A5%9E%E5%99%A8/id1440140641?mt=8'
            //     }else {
            //         if(ua.match(/MicroMessenger/i) === 'micromessenger' && isAndroid) {
            //             //应用宝
            //             window.location.href ='https://a.app.qq.com/o/simple.jsp?pkgname=com.fanqie.fqtsa';
            //             $('body,html').animate({scrollTop:0},300);
            //         }

            //         if(href.indexOf('dym') !== -1) {  //// 大姨妈渠道
            //             // alert('dym')
            //             return
            //         }else {
            //             if (device_type.indexOf('HUAWEI') > -1) {
            //                 // alert('huawei')
            //                 window.location.href = "market://details?id=com.fanqie.fqtsa"
            //             } else if (device_type.indexOf('OPPO') > -1||device_type.indexOf('Oppo') > -1) {
            //                 window.location.href = "market://details?id=com.fanqie.fqtsa"
            //             } else if (device_type.indexOf('vivo') > -1) {
            //                 window.location.href = "vivoMarket://details?id=com.fanqie.fqtsa"
            //             } else if (device_type.indexOf('MI') > -1 || device_type.indexOf('Mi') > -1 ) {
            //                 // alert('xiaomi')
            //                 window.location.href = "mimarket://details?id=com.fanqie.fqtsa"
            //             } else if (device_type.indexOf('baidu') > -1) {
            //                 window.location.href = "https://a.app.qq.com/o/simple.jsp?pkgname=com.fanqie.fqtsa"
            //             } else if (device_type.indexOf('360') > -1) {
            //                 window.location.href = "intent://details?id=com.fanqie.fqtsa#Intent;package=com.fanqie.fqtsa;scheme=market;end;"
            //             } else {  ///其他安卓手机
            //                 window.location.href = "https://a.app.qq.com/o/simple.jsp?pkgname=com.fanqie.fqtsa"
            //             }
            //         }
            //     }
            // }
        },
        mounted() {
            // var _czc = _czc || [];
            // _czc.push(["_setAccount", "1278736774"]);
            // const script = document.createElement('script')
            // script.src = 'https://s4.cnzz.com/z_stat.php?id=1278736774&web_id=1278736774'
            // script.language = 'JavaScript'
            // document.body.appendChild(script)
            // console.log(window)
            window.addEventListener('scroll', this.windowScroll)
            this.$refs.myAudio.currentTime = 0;
            let url = window.location.href;
            let arr = url.split('/');
            let index = arr.length-1;
            let bookid1 = url.split('/')[index];
            // console.log(bookid1)
            this.bookid = bookid1.split('?')[0];
            // console.log(this.bookid)
            axios.post('http://47.93.18.240/bookdetailstoh5.php', {"username":"13888888888","bookid":this.bookid})
                .then(resp => {
                    this.bookdetails = resp.data.data.bookdetails;
                    this.items = resp.data.data.recommend.recommend_array;
                    this.firstchaptername = this.bookdetails.firstchaptername;
                    this.$refs.myAudio.src = this.bookdetails.firstchaptermp3path;
                    this.firstchapterduration = this.bookdetails.firstchapterduration;
                    let playcount = this.bookdetails.playcount;
                    if (playcount.length < 5){
                        this.playcount = playcount;
                        return this.playcount;
                    }else {
                        let decimal = playcount.substring(playcount.length - 4, playcount.length - 4);
                        this.playcount = parseFloat(parseInt(playcount / 10000) + '.' + decimal) + '万';
                        return this.playcount
                    }
                }).catch(err => {
                console.log('请求失败：'+err.status+','+err.statusText);
            });
        },
        computed:{

        },
        beforeDestroy(){
            clearTimeout(this.timer)
        },
        watch: {
            '$route' () {
                this.fetchCaseInfo()
            },
        }
    }
</script>

<style lang="stylus" rel="stylesheet/stylus">
    html,body
        width 100%
        height 100%
        margin 0
        padding 0
        #wrap
            width 100%
            height 100%
            /*min-width 360px*/
            /*max-width 1024px*/
            .header
                position fixed
                left 0
                top -1px
                z-index: 999;
                width 960px
                transition .2s
                background:rgba(255,255,255,1);
                box-shadow:0 8px 8px 0 rgba(0,0,0,0.04);
                height 120px
                &.on
                    transform translateY(-120px)
                    transition .2s
                .rectangle_logo
                    margin-top 24px
                    margin-left 5%
                    width 72px;
                    float left
                    height 72px
                    img
                        width 72px;
                        height 72px
                .rectangle_text
                    height 64px
                    margin-top 24px
                    margin-left 30px
                    float left
                    .text_title
                        height:40px;
                        font-size:28px;
                        font-family:PingFangSC-Regular,PingFang SC;
                        font-weight:400;
                        color:rgba(56,55,54,1);
                        line-height:40px;
                    .text_scribe
                        height:34px;
                        font-size:24px;
                        font-family:PingFangSC-Regular,PingFang SC;
                        font-weight:400;
                        color:rgba(153,153,153,1);
                        line-height:34px;
                .rectangle_download
                    /*text-align center*/
                    margin-top 24px
                    margin-left   160px
                    float left
                    /*line-height 72px*/
                    width:172px;
                    height:72px;
                    background:rgba(255,102,60,1);
                    border-radius:36px;
                    font-size:28px;
                    font-family:PingFangSC-Regular,PingFang SC;
                    font-weight:400;
                    color:rgba(255,255,255,1);
                    display flex
                    justify-content center
                    align-items center
            .box
                width 100%
                height 100%
                position relative
                top 100px
                left 0
                .play_wrap
                    width 100%
                    height 396px
                    .detail_book
                        width 100%
                        position: relative;
                        .book_logo
                            width 192px
                            height 256px
                            position: absolute
                            left 60px
                            top 70px
                            background:rgba(216,216,216,1);
                            border-radius:12px;
                            overflow hidden
                            .look_times
                                position: absolute
                                bottom: 0;
                                width 100%
                                height 40px
                                left 0
                                display flex
                                align-items center
                                justify-content center
                                background:linear-gradient(180deg,rgba(0,0,0,0) 0%,rgba(0,0,0,0.4) 100%);
                                border-radius:0 0 12px 12px;
                                .playback
                                    width 20px
                                    height:20px;
                                    transform translateX(-4px)
                                    border-radius:2px;
                                    img
                                        width 20px
                                        height 20px
                                .playcount
                                    height:20px;
                                    font-size:24px;
                                    transform translateX(4px)
                                    font-family:PingFangSC-Regular,PingFang SC;
                                    font-weight:400;
                                    color:rgba(255,255,255,1);
                                    margin-top -8px
                            .logo_image
                                img
                                    width 192px
                                    height 256px
                        .book_person
                            height 64px
                            white-space nowrap
                            position absolute
                            left  292px
                            top 70px
                            .book_name
                                width 400px
                                overflow hidden
                                text-overflow ellipsis
                                font-family: SourceHanSansCN-Normal;
                                font-size: 36px;
                                color: rgba(56,55,54,1);
                                letter-spacing: 0.19px;
                                height 50px
                                line-height 50px
                                font-weight bold
                            .original_person
                                letter-spacing: 0;
                                width:308px;
                                margin-top 16px
                                height:40px;
                                font-size:28px;
                                font-family:PingFangSC-Regular,PingFang SC;
                                font-weight:400;
                                color:rgba(102,102,102,1);
                                line-height:40px;
                            .book_dub
                                overflow hidden
                                text-overflow ellipsis
                                margin-top 16px
                                letter-spacing: 0;
                                width:308px;
                                height:40px;
                                font-size:28px;
                                font-family:PingFangSC-Regular,PingFang SC;
                                font-weight:400;
                                color:rgba(102,102,102,1);
                                line-height:40px;
                            .book_times
                                margin-top 60px
                                width 100%
                                height 26px
                                position relative
                                font-family: SourceHanSansCN-Light;
                                font-size: 24px;
                                color: #787878;
                                letter-spacing: 0;
                                .book_gather
                                    width 196px
                                    >div
                                        float left
                                    .chapter
                                        width 22px
                                        height 20px
                                        img
                                            width 22px
                                            height 20px
                                    .booknumber
                                        width:80px;
                                        height:40px;
                                        font-size:28px;
                                        font-family:PingFangSC-Regular,PingFang SC;
                                        font-weight:400;
                                        color:rgba(102,102,102,1);
                                        line-height:40px;
                                        margin-left 10px;
                                        margin-top -6px
                .player
                    padding 0 60px
                    height 338px
                    .player_box
                        border-radius:12px;
                        border:2px solid rgba(238,238,238,1);
                        width 100%
                        height 338px
                        overflow hidden
                        position relative
                        .player_episode
                            position relative
                            width 100%
                            height:40px;
                            font-size:28px;
                            font-family:PingFangSC-Regular,PingFang SC;
                            font-weight:400;
                            color:rgba(102,102,102,1);
                            line-height:40px;
                            .playerName
                                width 100%
                                position absolute
                                left 0
                                text-align center
                                top 30px
                        .player_progress
                            position absolute
                            top 124px
                            left 5%
                            width 100%
                            height 338px
                            .current_Time
                                position absolute
                                left 0
                                top  44px
                                font-size:24px;
                                font-family:PingFangSC-Regular,PingFang SC;
                                font-weight:400;
                                color:rgba(102,102,102,1);
                                line-height:24px;
                            .progress
                                width 90%
                                position absolute
                                height 6px
                                left 0
                                top 10px
                                >div
                                    margin-top auto
                                    margin-bottom auto
                                    position absolute
                                    top 0
                                    left 0
                                    height 6px
                                .smallGrey
                                    width: 100%;
                                    /*float left*/
                                    border-radius 3px
                                    background: #EEEEEE;
                                    height 6px
                                    .smallWhite
                                        width: 16px ;
                                        height 16px
                                        left -2px
                                        background: #fff;
                                        float left
                                        position absolute
                                        border 8px solid #FF663C
                                        border-radius 50%
                                        top -11px
                                    .smallPink
                                        float left
                                        height 6px
                                        border-top-left-radius 3px
                                        border-bottom-left-radius 3px
                                        background: #FF663C
                            .all_Time
                                position absolute
                                left   80%
                                top 44px
                                font-size:24px;
                                font-family:PingFangSC-Regular,PingFang SC;
                                font-weight:400;
                                color:rgba(102,102,102,1);
                                line-height:24px;
                        .menu
                            position: absolute;
                            top 57%
                            left 50%
                            transform translateX(-50%)
                            display flex
                            .lastSong
                                width 40px
                                height 40px
                                transform translate(-98px,100%)
                                img
                                    width 40px
                                    height 40px
                            .menu_btn
                                width 120px
                                height  120px
                                border-radius 50%
                                background: #FF663C
                                background:rgba(255,102,60,1);
                                box-shadow:0 4px 8px 0 rgba(154,50,21,0.3);
                                border:2px solid rgba(255,255,255,1);
                                >div
                                    margin-left 50%
                                    transform translate(-50%,-50%)
                                    margin-top 50%
                                    display none
                                    &.on
                                        display block
                                .menu_btn_start
                                    width 45px
                                    height 45px
                                    img
                                        width 45px
                                        height 45px
                                .menu_btn_timg
                                    width 45px
                                    height 45px
                                    img
                                        width 45px
                                        height 45px
                                .menu_btn_pause
                                    width 45px
                                    height 45px
                                    img
                                        width 45px
                                        height 45px
                            .nextSong
                                transform translate(98px,100%)
                                width 40px
                                height 40px
                                img
                                    width 40px
                                    height 40px
                .play_catail
                    width 100%
                    margin-bottom 560px
                    .detail_all
                        margin-top 70px
                        padding 0 60px
                        .book_content
                            position: relative;
                            .content_title
                                height:50px;
                                font-size:36px;
                                font-family:PingFangSC-Semibold,PingFang SC;
                                font-weight:bold;
                                color:rgba(56,55,54,1);
                                line-height:50px;
                            .content_introduce
                                margin-top 30px
                                line-height 45px
                                font-size:28px;
                                font-family:PingFangSC-Regular,PingFang SC;
                                font-weight:400;
                                color:rgba(102,102,102,1);
                        .guess_title
                            letter-spacing: 0;
                            text-align: left;
                            height:50px;
                            font-size:36px;
                            font-family:PingFangSC-Semibold,PingFang SC;
                            font-weight:bold;
                            color:rgba(56,55,54,1);
                            line-height:50px;
                            margin-top 60px
                        .guess_list
                            margin-top 30px
                            width 100%
                            padding 0
                            .guess_items
                                margin-right 10px
                                list-style none
                                float left
                                .book_logo
                                    width 180px
                                    height 240px
                                    background:rgba(216,216,216,1);
                                    border-radius:12px;
                                    overflow hidden
                                    border:2px solid rgba(245,246,247,1);
                                    img
                                        display block
                                        width 180px
                                        height 240px
                                .book_title
                                    width 200px
                                    margin-top: 20px
                                    font-family: SourceHanSansCN-Light;
                                    font-size: 30px;
                                    color: #1A1A1A;
                                    height 90px
                                    letter-spacing: 0;
                                    overflow hidden
                                    text-overflow ellipsis
                                    display:-webkit-box;
                                    -webkit-box-orient:vertical;
                                    -webkit-line-clamp:2;
                .detail_play
                    position fixed
                    bottom 0
                    left 0
                    width 100%
                    background:linear-gradient(180deg,rgba(255,255,255,0) 0%,rgba(255,255,255,1) 100%);
                    height:138px;
                    margin-bottom -138px
                    padding 0 60px
                    text-align center
                    transition .2s
                    overflow hidden
                    z-index 999
                    &.on
                        margin-bottom 0
                        transition .2s
                    .detail_box
                        background: #FF5C1F
                        height 88px
                        line-height 88px
                        width 84%
                        border-radius 60px
                        font-size:32px;
                        font-family:PingFangSC-Regular,PingFang SC;
                        font-weight:400;
                        color:rgba(255,255,255,1);
                .curtain
                    width 100%
                    display none
                    height  100%
                    background:rgba(0,0,0,0.6);
                    position fixed
                    top 0
                    left 0
                    z-index 999
                    &.on
                        display block
                    .promptBox
                        width 80%
                        height 428px
                        background:rgba(255,255,255,1);
                        border-radius 24px
                        position absolute
                        left 0
                        top 0
                        bottom 0
                        right 0
                        margin auto
                        >div
                            font-family: SourceHanSansCN-Medium;
                            font-size: 30px;
                            color: #1A1A1A;
                            letter-spacing: 0;
                            text-align: center;
                            font-weight bold
                        .curtain_download
                            height:56px;
                            font-size:40px;
                            font-family:PingFangSC-Semibold,PingFang SC;
                            font-weight:bold;
                            color:rgba(56,55,54,1);
                            line-height:56px;
                            margin-top 90px
                        .unchain
                            height:44px;
                            font-size:32px;
                            font-family:PingFangSC-Regular,PingFang SC;
                            font-weight:400;
                            color:rgba(56,55,54,1);
                            line-height:44px;
                            margin-top 40px
                        .curtainBtn
                            width 240px
                            height 80px
                            margin-top  70px
                            background: #FF5C1F
                            line-height 80px
                            background:rgba(255,102,60,1);
                            border-radius:44px;
                            transform translateX(70%)
                            font-size:32px;
                            font-family:PingFangSC-Regular,PingFang SC;
                            font-weight:400;
                            color:rgba(255,255,255,1);
                    .promptFork
                        width 30px
                        height 30px
                        position absolute
                        right 30px
                        top 30px
                        img
                            display block
                            width 30px
                            height 30px
</style>
